import { type FeatureFlagNames, useFeatureFlag } from '@/contexts/feature-flag'

interface WithFeatureFlagProps {
  featureFlagName: FeatureFlagNames
  fallbackValue?: boolean
  children: React.ReactNode
}

export function WithFeatureFlag(props: WithFeatureFlagProps) {
  const { featureFlagName, children, fallbackValue = false } = props

  const isFeatureEnabled = useFeatureFlag(featureFlagName, fallbackValue)

  return <>{isFeatureEnabled && children}</>
}
